let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7lKMr")).then(() => parcelRequire('eMenI'));